module.exports = __webpack_public_path__ + "static/sport/regist.09019e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/regist.gif
// module id = 4hx1
// module chunks = 0